import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceDetails from "./sections/ServiceDetails";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import ReadyToBook from "./sections/ReadyToBook";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceDetails />
      <FrequentlyAskedQuestions />
      <ReadyToBook />
      <Footer />
    </div>;
}